import { styled } from "themes"
import leaves from "../../../../images/leaves.png"
import leavesLighter from "../../../../images/leaves-lighter.png"

export const Section = styled.section`
  height: 692px;
`

export const Container = styled(Section)`
  background: url(${leavesLighter}), url(${leaves});
  background-position: center;
  background-size: cover;
  overflow: hidden;
  position: relative;
`

export const Content = styled.div`
  position: absolute;
  bottom: 200px;
  left: 216px;
`

export const FirstHeadline = styled.h3`
  color: ${({ theme }) => theme.color.white};
  font-size: 70px;
  line-height: 70px;
  font-weight: bold;
  margin-bottom: 0;
  margin-left: 16px;
`

export const SecondHeadline = styled(FirstHeadline)`
  font-size: 126px;
  line-height: 100px;
  margin-left: 0;
  margin-bottom: 24px;
`

export const Action = styled.div`
  color: #000;
  background: ${({ theme }) => theme.color.white};
  font-size: 27px;
  font-weight: 500;
  max-width: 536px;
  width: 100%;
  outline: none;
  border: 1px solid #707070;
  cursor: pointer;
  padding: 6px 0;
  padding-left: 60px;
`
